import React from 'react';
import styled from 'styled-components';

const StyledModal = styled.div`
	z-index: 1800;
	position: absolute;
	> div {
		width: 100%;
		max-width: 330px;
		min-height: 370px;
		padding: 24px;
		height: auto;
		background: ${(props) => props.theme.colors.colorWhite};
		border: none;
		border-radius: 32px;
	}
`;

const AppModal = ({ show, children }) => {
	return (
		<StyledModal show={show}>
			<div>{children}</div>
		</StyledModal>
	);
};

export default AppModal;
